import * as React from "react";
// import "./TrackerTable.css";
import { DataGrid } from "@mui/x-data-grid";
import "../Styles/CmmTable.module.css";
import { useNavigate } from "react-router-dom";
import { ls } from "../../../../variables";
import { useStateValue } from "../../../../Hooks/stateProvider";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CustomNoRowsOverlay from "../../../../components/CustomNoRowsOverlay";
import Loader from "../../../../Loader/Loader";

export default function TrakerTable({ rows, previewFunc, type, fy_year, quarter }) {
  
  const navigate = useNavigate();
  const [selectpreview, setSelectPreview] = React.useState();

  const [state, dispatch] = useStateValue();

  const handleChangePreview = (state) => {
    setSelectPreview(state)

    previewFunc(selectpreview);
  }


  // }
  const cmmColumns = [

    {
      field: "index",
      headerName: "S.NO",
      minWidth: 40,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "unreadAlert",
      headerName: "",
      minWidth: 30,
      maxWidth: 40,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return (
        <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>   
          {params.row.status == "open" && <PriorityHighIcon />}
        </div>)
      }
    },
    {
      field: "particulars",
      headerName: "Particulars",
      minWidth: 300,
      flex: 0.7,
      align: "left",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "view",
      headerName: "Details",
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ paddingRight: "5px" }}>
              <button
                style={{
                  color: "#ffffff",
                  backgroundColor: "#154063",
                  border: "0.125rem solid #154063",
                  borderRadius: "0.125rem",
                  width: "6.5rem",
                  cursor: "pointer",
                  height: "1.875rem",
                }}
                onClick={() => {
                  ls.set("type", "cmm");
                  const props = {
                    id: params.id,
                    particulars: params.row.particulars,
                    status: params.row.status,
                    fy_year: fy_year,
                    quarter: quarter,
                    moduleType: type.toUpperCase()

                  }
                  dispatch({
                    type: "CMMTrackerPageData",
                    CMMTrackerPageData: {
                      cmm_id: params.row.id,
                      fy_year: fy_year,
                      quarter: quarter

                    },
                  });

                  navigate("/app/cmmView", { state: props });
                }}
              >
                View
              </button>
            </div>
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return(
        <div style={{fontSize:"1rem"}}>
          {params.row.status == "open" || params.row.status == "open (sebi)" ? "open" : params.row.status }
        </div>)
      }
    },
  ];
  

  let columns;
  type == "cmm" ? (columns = cmmColumns) : (columns = cmmColumns);

  return (
    <div style={{ height: "100%", width: "100%", marginTop: "0%" }}>
      <Loader />
      <DataGrid
        getRowHeight={() => "auto"}
        rows={rows}
        columns={columns}
        sx={{
          width: "fit-content",
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "0.8rem"

          },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaders": {width: "fit-content"},
          "& .MuiDataGrid-topContainer": {width: "fit-content"},
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
          "& .MuiDataGrid-overlayWrapper": {
            position: "static"
          }
        }}
        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        onRowSelectionModelChange={(selectedRowsID) => {
          const selectedIDs = new Set(selectedRowsID);
          selectedIDs.size == rows.length ? handleChangePreview(true) : handleChangePreview(false)
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay
        }}
        rowsPerPageOptions={[2, 5, 10]}
        AutoGenerateColumns={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        disableColumnSelector
        scrollbarSize={0}
        autoPageSize
      />
    </div>
  );
}
